/**
 * @generated SignedSource<<584e4215f59bc7f1f8f87a676e882d46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendNoteToZapierInput = {
  clientMutationId?: string | null;
  customData?: string | null;
  noteId: string;
};
export type SendNotesModalSendNoteToZapierMutation$variables = {
  input: SendNoteToZapierInput;
};
export type SendNotesModalSendNoteToZapierMutation$data = {
  readonly sendNoteToZapier: {
    readonly ok: boolean;
  } | null;
};
export type SendNotesModalSendNoteToZapierMutation = {
  response: SendNotesModalSendNoteToZapierMutation$data;
  variables: SendNotesModalSendNoteToZapierMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendNoteToZapierPayload",
    "kind": "LinkedField",
    "name": "sendNoteToZapier",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendNotesModalSendNoteToZapierMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendNotesModalSendNoteToZapierMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "380ffa9391918da4fb1e42c2f5d628cd",
    "id": null,
    "metadata": {},
    "name": "SendNotesModalSendNoteToZapierMutation",
    "operationKind": "mutation",
    "text": "mutation SendNotesModalSendNoteToZapierMutation(\n  $input: SendNoteToZapierInput!\n) {\n  sendNoteToZapier(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "10feda4ecfe98da45af452b078b53db0";

export default node;
